import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as APIS from "../../../../../services/apis";

export function* handleFetchUserDetails({ payload }) {
  try {
    const res = yield call(APIS.fetchUserDetails, payload);
    const { data } = res;
    yield put(actions.fetchUserDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchUserDetailsFailure(err?.response?.data));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* userViewSaga() {
  yield takeLatest(actions.fetchUserDetails.type, handleFetchUserDetails);
}
